/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadAttachments200Response
 */
export interface UploadAttachments200Response {
    /**
     * 
     * @type {Array<number>}
     * @memberof UploadAttachments200Response
     */
    attachmentIds?: Array<number>;
}

/**
 * Check if a given object implements the UploadAttachments200Response interface.
 */
export function instanceOfUploadAttachments200Response(value: object): value is UploadAttachments200Response {
    return true;
}

export function UploadAttachments200ResponseFromJSON(json: any): UploadAttachments200Response {
    return UploadAttachments200ResponseFromJSONTyped(json, false);
}

export function UploadAttachments200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadAttachments200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'attachmentIds': json['attachment_ids'] == null ? undefined : json['attachment_ids'],
    };
}

export function UploadAttachments200ResponseToJSON(json: any): UploadAttachments200Response {
    return UploadAttachments200ResponseToJSONTyped(json, false);
}

export function UploadAttachments200ResponseToJSONTyped(value?: UploadAttachments200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attachment_ids': value['attachmentIds'],
    };
}

